import { render, staticRenderFns } from "./UserAnchor.vue?vue&type=template&id=38c28453&"
import script from "./UserAnchor.vue?vue&type=script&lang=js&"
export * from "./UserAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports